export const ROBOTDATA_DETAILS = "ROBOTDATA_DETAILS";
export const CONNECTION_ROBOT = "CONNECTION_ROBOT";
export const BOT_DETAILS = "BOT_DETAILS";
export const BOT_AVAILABILITY = "BOT_AVAILABILITY";
export const GET_MISSIONS = "GET_MISSIONS";
export const SINGLE_MISSION = "SINGLE_MISSION";
export const SOL_BALANCE = "SOL_BALANCE";
export const USDC_BALANCE = "USDC_BALANCE";
export const TIME_CREDIT = "TIME_CREDIT";
export const THEME_ACTIVE = "THEME_ACTIVE";
export const MIC_MUTED = "MIC_MUTED";
export const AUDIO_MUTED = "AUDIO_MUTED";
export const CHECK_POINT_ACHIEVE = "CHECK_POINT_ACHIEVE";
export const CHECK_POINT_DISTANCE_METER = "CHECK_POINT_DISTANCE_METER";
export const MISSION_COMPLETE = "MISSION_COMPLETE";
export const TOTAL_DRIVING_TIME = "TOTAL_DRIVING_TIME";
export const TOTAL_DRIVING_MIN = "TOTAL_DRIVING_MIN";
export const BUY_TC = "BUY_TC";
export const HIDE_MENU = "HIDE_MENU";
export const COIN_NAME = "COIN_NAME";
export const COIN_BALANCE_NUMBER = "COIN_BALANCE_NUMBER";
export const MISSION_ALPHA = "MISSION_ALPHA";
export const MISSION_GAMMA = "MISSION_GAMMA";
export const LOADING_SPINNER = "LOADING_SPINNER";
export const PAYMENT_PROCESS = "PAYMENT_PROCESS";
export const CHECK_REGISTER = "CHECK_REGISTER";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const FRODOBOT_ID = "FRODOBOT_ID";
export const TRANSACTION_CHECKOUT = "TRANSACTION_CHECKOUT";
export const ACHIEVE_POINT = "ACHIEVE_POINT";
export const BALANCE_CHECK = "BALANCE_CHECK";
export const IS_MAIN_SCREEN = "IS_MAIN_SCREEN";
export const CLEAR_REDUX = "CLEAR_REDUX";
export const STRPIE_PAYMNET = 'STRPIE_PAYMENT';
export const CLIENT_SECRET = 'CLIENT_SECRET';
export const PAYMENT_AMOUNT = 'PAYMENT_AMOUNT';
export const SET_USER = 'SET_USER';
export const STATUS_DETAILS = 'STATUS_DETAILS';
export const HEAD_LIGHT = 'HEAD_LIGHT';
export const SHOW_DRIVE_BUTTON = 'SHOW_DRIVE_BUTTON';
export const MISSION_FEEDBACK = 'MISSION_FEEDBACK';
export const FULL_LICENCE_META_DATA = 'FULL_LICENCE_META_DATA';
export const LAST_CHECK_POINT = 'LAST_CHECK_POINT';
export const CREATE_RIDE = 'CREATE_RIDE';
export const NEW_MISSION = 'NEW_MISSION';
export const ALL_BOT = 'ALL_BOT';
export const TOURNAMENT_FINISH = 'TOURNAMENT_FINISH'
export const TOURNAMENT_SELECTED = 'TOURNAMENT_SELECTED';
export const BUCKET_BASE_POINT = 'BUCKET_BASE_POINT';
export const BUCKET_ADD_POINT = 'BUCKET_ADD_POINT';
export const FINAL_TEAM_SCORE = 'FINAL_TEAM_SCORE';
export const GET_PLAYER_DISTANCE = 'GET_PLAYER_DISTANCE';
export const AGORA_TOKEN = 'AGORA_TOKEN';
export const PVE_GAME_PLAY = 'PVE_GAME_PLAY';
export const SCAN_CHECKPOINT_LIST = 'SCAN_CHECKPOINT_LIST';
export const ALL_SCAN_CHECKPOINT_LIST = 'ALL_SCAN_CHECKPOINT_LIST';
export const GPT_SCAN_CHECKPOINT_RESPONECE = 'GPT_SCAN_CHECKPOINT_RESPONECE';
export const GPT_ERROR_TOAST = 'GPT_ERROR_TOAST';
export const GPT_MESSAGE_TOAST = 'GPT_MESSAGE_TOAST';
export const ALL_SCAN_CHECK_POINT_TOAST = 'ALL_SCAN_CHECK_POINT_TOAST';
export const TEST_DRIVE_COMPLECT = 'TEST_DRIVE_COMPLECT';
export const TEST_DRIVE_COMPLETE_SEVEN_POINT = 'TEST_DRIVE_COMPLETE_SEVEN_POINT';
export const TIME_LEFT = 'TIME_LEFT';
export const TEST_DRIVE_TIMER = 'TEST_DRIVE_TIMER';
export const MENU_OPEN_MODEL = 'MENU_OPEN_MODEL';
export const RIDE_START_TIME = 'RIDE_START_TIME';
export const ABXY_BUTTON = 'ABXY_BUTTON';
export const JOY_STICK_BUTTON = 'JOY_STICK_BUTTON';
export const SPEED_BUTTON = 'SPEED_BUTTON';
export const DEFAULT_BUTTON_OPTIONS = 'DEFAULT_BUTTON_OPTIONS';
export const DEFAULT_JOYSTICK_BUTTON_OPTIONS = 'DEFAULT_JOYSTICK_BUTTON_OPTIONS';
export const DEFAULT_SPEED_BUTTON_OPTIONS = 'DEFAULT_SPEED_BUTTON_OPTIONS';
export const BUTTON_CONFIGURATIONS = 'BUTTON_CONFIGURATIONS';
export const JOYSTICK_KEY_CONFIGURATIONS = 'JOYSTICK_KEY_CONFIGURATIONS';
export const SPEED_KEY_CONFIGURATIONS = 'SPEED_KEY_CONFIGURATIONS';
export const KEY_MAPPING_BUTTON = 'KEY_MAPPING_BUTTON';
export const KEY_MAPPING_DEFAULT_BUTTON = 'KEY_MAPPING_DEFAULT_BUTTON';
export const KEYBORARD_KEY = 'KEYBORARD_KEY';
export const IS_BUY_NFT = 'IS_BUY_NFT';
export const IS_KYC_MODEL = 'IS_KYC_MODEL';
export const MENU_MODEL = 'MENU_MODEL';
export const LAYOUT_SET_OPENWORLD = 'LAYOUT_SET_OPENWORLD';
export const TESTDRIVE_RIDE_ID = 'TESTDRIVE_RIDE_ID';
export const RULES_MODEL = 'RULES_MODEL';
export const RACE_CONDITION_MODEL = 'RACE_CONDITION_MODEL';
export const CHECK_USER_STILL_MODEL = 'CHECK_USER_STILL_MODEL';
export const SUSPICIOUS_ACTIVITY_MODEL = 'SUSPICIOUS_ACTIVITY_MODEL';
export const PROFILE_MODEL = 'PROFILE_MODEL';
export const MINOR_PENALTY = 'MINOR_PENALTY';
export const MAJOR_PENALTY = 'MAJOR_PENALTY';
export const PENALTYDATA = 'PENALTYDATA';
export const LEVEL_ACHIEVED_MODEL = 'LEVEL_ACHIEVED_MODEL';
export const NO_TESTDRIVE_BOT = 'NO_TESTDRIVE_BOT';
export const TOTAL_RECORDING_TIME = 'TOTAL_RECORDING_TIME';
export const TOTAL_RECORDING_MIN = 'TOTAL_RECORDING_MIN';
export const SCAVENGER_DROPS = 'SCAVENGER_DROPS';
export const REACHED_SCAVENGER_DROPS_CHECKPOINT = 'REACHED_SCAVENGER_DROPS_CHECKPOINT';
export const REACHED_SCAVENGER_DROPS_CHECKPOINT_DATA = 'REACHED_SCAVENGER_DROPS_CHECKPOINT_DATA';
export const REACHED_SCAVENGER_DROPS_FLAG = 'REACHED_SCAVENGER_DROPS_FLAG';
export const REACHED_LATEST_NFT_DROPS_CHECKPOINT = 'REACHED_LATEST_NFT_DROPS_CHECKPOINT';
export const REACHED_NFT_DROPS = 'REACHED_NFT_DROPS';
export const REACHED_NFT_DROPS_LIST = 'REACHED_NFT_DROPS_LIST';
export const FAILED_MINTED_NFT_DROPS_LIST = 'FAILED_MINTED_NFT_DROPS_LIST';
export const FAILED_MINTED_NFT_DROP = 'FAILED_MINTED_NFT_DROP';
export const TOGGLE_DRIVE_MODE = 'TOGGLE_DRIVE_MODE';
export const SET_ENABLED_DRIVE_MODES = 'SET_ENABLED_DRIVE_MODES';
